console.log("init Proteus treatments -- 2.02")

if(window.location.href.indexOf("/products/4lb-collagen-peptides-bag") > -1){}
// 4lb PDP -- hide WEEKS options
/* 
1mo: 1241153671
2mo: 1241186439
3mo: 1241219207
4wk: 3022454919
6wk: 3022487687
8wk: 3022520455
12wk: 3022553223
24wk: 3022585991
*/
waitForElement('skio-plan-picker').then(plan_picker => {

    waitUntil(() => {

        return !!(
            plan_picker.shadowRoot &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown') &&
            plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options.length > 0
        );

    }).then(() => {

        let selling_plans_options = plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options;
        for(let i = 0; i < selling_plans_options.length; i++){
            if(selling_plans_options[i].value == "3022454919" || 
            selling_plans_options[i].value == "3022487687" || 
            selling_plans_options[i].value == "3022520455" || 
            selling_plans_options[i].value == "3022553223" || 
            selling_plans_options[i].value == "3022585991"){
                selling_plans_options[i].hidden = true;
            } 
        }

    }).catch();

}).catch();

window.sessionStorage.setItem("GLW-02", "v1");
if(window.sessionStorage.getItem("GLW-02") == "v1"){

  console.log("init [GLW-02]v1")

      /*

  10oz - Quantity 2 // every 4 weeks
  16oz - Quantity 2 // every 6 weeks
  32oz Quantity 1 // every 6 weeks
  4lbs Quantity 1 // every 12 weeks 
  4lbs Quantity 1 // every 6 weeks (2 servings per day)
  8lbs Quantity 1 // every 24 weeks 
  8lbs Quantity 1 // every 12 weeks (2 servings per day)

  1mo: 1241153671
  2mo: 1241186439
  3mo: 1241219207
  4wk: 3022454919
  6wk: 3022487687
  8wk: 3022520455
  12wk: 3022553223
  24wk: 3022585991

  */

  let page_slug = window.location.pathname.split("/").filter(Boolean).pop() || "";
  let max_per_serving = 1.79;

  let product_options = [
    {
      name: "10oz",
      servings: 14,
      price: 24.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_US_Bovine_10oz_Front.png?v=1748274455&width=375",
      slug: "10-oz-collagen-peptides",
      options: [
        "2 // Delivery every 4 Weeks (1 serving per day) // 3022454919"
      ]
    },
    {
      name: "16oz",
      servings: 22,
      price: 29.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_render_US_Bovine16oz_Front.png?v=1748273057&width=375",
      slug: "16oz-collagen-peptides",
      options: [
        "2 // Delivery every 6 Weeks (1 serving per day) // 3022487687"
      ]
    },
    {
      name: "32oz",
      servings: 45,
      price: 52.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/32oz_Collagen_Peptides_Front.png?v=1747784421&width=375",
      slug: "32oz-collagen-peptides",
      options: [
        "1 // Delivery every 6 Weeks (1 serving per day) // 3022487687"
      ]
    },
    {
      name: "4lb",
      servings: 90,
      price: 99.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/4lb-Unflavored-Bovine_Front_4b105bc6-6eb5-4d74-9238-3ed87c5143d4.png?v=1748279014&width=375",
      slug: "4lb-collagen-peptides-bag",
      options: [
        "1 // Delivery every 12 Weeks (1 serving per day) // 3022553223",
        "1 // Delivery every 6 Weeks (2 servings per day) // 3022487687"
      ]
    },
    {
      name: "8lb",
      servings: 181,
      price: 169.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW-Unflavored-8lb-Rendering-Front.png?v=1748273229&width=375",
      slug: "8lb-collagen-peptides",
      options: [
        "1 // Delivery every 24 Weeks (1 serving per day) // 3231056007",
        "1 // Delivery every 12 Weeks (2 servings per day) // 3231023239"
      ]
    },
    {
      name: "20 sticks",
      servings: 20,
      price: 29.99,
      img: "https://greatlakeswellness.com/cdn/shop/files/GLW_render_US_Bovine_BoxStick.png?v=1748274887&width=375",
      slug: "20ct-collagen-peptides-stick-pack",
      options: []
    }
  ];

  let selected_product;
  let page_targeted = false;

  for(let i = 0; i < product_options.length; i++){
    if(page_slug == product_options[i].slug){
      selected_product = product_options[i];
      page_targeted = true;
      break;
    }
  }

  if(page_targeted && selected_product.options.length > 0){

    let selected_plan_qty = parseInt(selected_product.options[0].split(" // ")[0]);

    let otp_full_price = `$${(max_per_serving * selected_product.servings).toFixed(2)}`;
    let otp_sale_price = `$${(selected_product.price).toFixed(2)}`;
    let otp_savings_amount = `$${(max_per_serving * selected_product.servings - selected_product.price).toFixed(2)}`;
    let sub_full_price = `$${(max_per_serving * selected_product.servings).toFixed(2)}`;
    let sub_sale_price = `$${((selected_product.price) * .85).toFixed(2)}`;
    let sub_savings_amount = `$${(max_per_serving * selected_product.servings - (selected_product.price * .85)).toFixed(2)}`;

    if(page_slug.indexOf("10-oz") > -1){
      otp_full_price = "";
      sub_full_price = `$${(selected_product.price * 2).toFixed(2)}`;
      sub_sale_price = `$${((selected_product.price * .85) * 2).toFixed(2)}`;
      sub_savings_amount = `$${((selected_product.price - (selected_product.price * .85)) * 2).toFixed(2)}`;
    }

    if(page_slug.indexOf("16oz") > -1){
      sub_full_price = `$${(max_per_serving * selected_product.servings * 2).toFixed(2)}`;
      sub_sale_price = `$${((selected_product.price * .85) * 2).toFixed(2)}`;
      sub_savings_amount = `$${((max_per_serving * selected_product.servings - (selected_product.price * .85)) * 2).toFixed(2)}`;
    }

    let options_html = "";
    for(let i = 0; i < product_options.length; i++){
      
      let is_out_of_stock = product_options[i].name == "20 sticks" ? "out-of-stock" : "";
      let is_current = product_options[i] == selected_product ? "current" : "";

      let img_html = `<img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" />`;
      if(product_options[i].name == "10oz" || product_options[i].name == "16oz"){
        img_html = `
          <img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" style="left: -20px;" />
          <img src="${product_options[i].img}" width="200" height="200" class="motion-reduce product-image" style="left: 20px;" />
        `;
      }

      options_html += `
      <li class="product-sibling-item size--${product_options[i].name.replace(" ", "")}">
        <a href="/products/${product_options[i].slug}" class="unstyled-link sibling-product-card ${is_current} ${is_out_of_stock}">

          <div class="card-media media-square">
            <div class="media">
              ${img_html}
            </div>
          </div>
          <span class="variant-name label paragraph-sm bold">${product_options[i].name}</span><span class="variant-name paragraph-sm" style="font-size: 10px; margin-top: -24px;">
            <span class="js-show--otp" style="font-size: inherit;">${product_options[i].servings}</span>
            <span class="js-show--sub" class="js-show--otp" style="font-size: inherit;">${parseInt(product_options[i].servings) * 2}</span> 
          Servings</span>
          <span class="variant-name paragraph-sm js-per-serving--otp">
            $${(product_options[i].price / product_options[i].servings).toFixed(2)} each
          </span>
          <span class="variant-name paragraph-sm js-per-serving--sub">
            $${((product_options[i].price / product_options[i].servings) * 0.85).toFixed(2)} each
          </span>
        </a>
      </li>
      `;
    }

    let delivery_options_html = "";
    for(let i = 0; i < selected_product.options.length; i++){

      let plan_qty = selected_product.options[i].split(" // ")[0];
      let plan_label = selected_product.options[i].split(" // ")[1];
      let plan_id = selected_product.options[i].split(" // ")[2];

      let is_selected = i == 0 ? "selected" : "";

      delivery_options_html += `
      <option ${is_selected} value="${plan_id}:${plan_qty}">
        ${plan_label}
      </option>
      `;
    }

    waitForElement('.skio-plan-picker').then(pdp_atc => {

      pdp_atc.insertAdjacentHTML("beforebegin", `

        <style>
          [class*="js-per-serving--"]{
            font-size: 9px; 
            margin-top: -24px; 
            margin-bottom: -5px;
          }

          .product-siblings{
            padding: 12px 12px 10px 12px;
            border: 1px solid var(--color-border);
            border-radius: 4px;
            margin-bottom: 16px;
            opacity: 0.8;
            cursor: pointer;
          }

          .product-siblings.is-selected{
            padding: 12px 12px;
            border: 2px solid #114734;
            border-radius: 4px;
            margin-top: 16px;
          }

          .product-siblings:not(.is-selected) .product-option-heading{
            margin-bottom: 0;
          }

          .product-siblings:not(.is-selected) circle.skio-radio,
          .product-siblings:not(.is-selected) .product-servings.product-savings,
          .product-siblings:not(.is-selected) .product-siblings-overflow,
          .js-options--sub .js-per-serving--otp,
          .js-options--otp .js-per-serving--sub, 
          [data-slug="10-oz-collagen-peptides"] .js-otp .product-savings,
          .js-options--otp .product-sibling-item .media img:nth-child(2),
          pdp-price,
          product-info > .product-siblings, 
          .skio-plan-picker .product-option-heading,
          .skio-plan-picker skio-plan-picker,
          .product-buy-buttons .quantity-input-form,
          .js-options--otp .js-show--sub,
          .js-options--sub .product-sibling-item:not(.size--10oz, .size--16oz) .js-show--sub,
          .js-options--sub .product-sibling-item.size--10oz .js-show--otp,
          .js-options--sub .product-sibling-item.size--16oz .js-show--otp
          {
            display: none;
          }

          .js-options--sub .product-sibling-item.size--10oz span.variant-name.label:after,
          .js-options--sub .product-sibling-item.size--16oz span.variant-name.label:after{
            content: " x 2";
          }

          .js-options--otp .product-sibling-item.size--10oz .media img,
          .js-options--otp .product-sibling-item.size--16oz .media img{
            left: 0 !important;
          }

      .product-sibling-item.thirty-two a:after,
      .product-sibling-item.size--32oz a:after {
          content:"Most Popular";
          background: #114734;
          color: white;
          position: absolute;
          text-align: center;
          top: -8px;
          right: 5px;
          width: calc(100% - 10px);
          padding: 2px 10px 0 10px;
          font-size: 8px;
          line-height: 2;
          border-radius: 4px;
          font-weight: var(--font-weight-extra-bold);
          font-family: var(--font-family-base);
      }
      .product-sibling-item.eight-pound a:after,
      .product-sibling-item.size--8lb a:after {
          content:"Best Value";
          background: white;
          color: #114734;
          position: absolute;
          text-align: center;
          top: -8px;
          right: 5px;
          width: calc(100% - 10px);
          padding: 2px 10px 0 10px;
          font-size: 8px;
          line-height: 1.5;
          border-radius: 4px;
          font-weight: var(--font-weight-extra-bold);
          font-family: var(--font-family-base);
          border: 1px solid #114734
      }
      .product-siblings {
          overflow: hidden;
      }

      span[id*="sale-price"]{
        font-weight: 800;
      }

      @media screen and (max-width: 1280px) {
        .product-siblings-overflow .product-sibling-item .variant-name {
            line-height: 1.5;
        }
      }

      @media screen and (max-width: 768px) {
          [class*="js-per-serving--"]{
            margin-bottom: 5px !important;
          }

          .sibling-product-card {
              padding-bottom: 0!important;
          }
          .sibling-product-card .variant-name.paragraph-sm:nth-of-type(2) {
              margin-top: -18px!important;
              margin-bottom: 20px;
          }
          .product-sibling-item {
              width: 120px!important;
          }
      }
      </style>

      <div class="js-purchase-options" data-slug="${page_slug}">

        <div class="product-siblings js-otp">
          <div class="skio-radio__container" style="position: absolute; margin-top: -2px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
              <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
            </svg>
          </div>
          <div class="product-option-heading">
            <h2 class="subtitle-sm" style="margin-left: 30px;">One-Time Size Options</h2>
            <p class="product-servings paragraph-sm" style="font-weight: 800;">
              <span style="text-decoration: line-through; font-size: 75%;" id="js-otp-full-price">${otp_full_price}</span> 
              <span id="js-otp-sale-price">${otp_sale_price}</span>
            </p>
          </div>
          <p class="product-servings paragraph-sm product-savings" style="text-align: right; margin-top: -18px; font-size: 75%; margin-bottom: 18px;">
            You Save <span id="js-otp-savings-amount">${otp_savings_amount}</span>!
          </p>
          <ul class="product-siblings-overflow list-unstyled js-options--otp" style="position: relative;">
            ${options_html}
          </ul>
        </div>

        <div class="product-siblings js-subs">
          <div class="skio-radio__container" style="position: absolute; margin-top: -2px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
              <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
            </svg>
          </div>
          <div class="product-option-heading">
            <h2 class="subtitle-sm" style="margin-left: 30px;">Auto Delivery Options</h2>

            <p class="product-servings paragraph-sm" style="font-weight: 800;">
            <span style="text-decoration: line-through; font-size: 75%;" id="js-subs-full-price">${sub_full_price}</span> 
            <span id="js-subs-sale-price">${sub_sale_price}</span></p>
          </div>
          <p class="product-servings product-savings paragraph-sm" style="text-align: right; margin-top: -18px; font-size: 75%; margin-bottom: 18px;">You Save <span id="js-subs-savings-amount">${sub_savings_amount}</span>!</p>
          <ul class="product-siblings-overflow list-unstyled js-options--sub" style="position: relative;">
            ${options_html}
          </ul>
          
          <select class="selling-plan-dropdown"
            style="width: 100%; font-size: 12px; background: white; border: 1px solid #114734; padding: 10px 10px 8px 10px; margin-top: 12px; border-radius: 2px; background-image: url(&quot;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false' role='presentation' viewBox='0 0 24 24' fill='none'%3E%3Cpath stroke-width='0' fill='%23114734' d='M21.4,6.6l-9.4,6.6L2.6,6.6l-.6.9,8.5,8.9c.7.8,1.1,1,1.5,1s.8-.3,1.5-1l8.5-8.9-.6-.9Z'/%3E%3C/svg%3E&quot;); background-repeat: no-repeat; background-position: calc(100% - 6px); background-size: 20px;">
            
            ${delivery_options_html}
            
          </select>
        </div>
        
      </div>
      `);

      waitForElement('skio-plan-picker').then(plan_picker => {

          waitUntil(() => {

            return !!(
              plan_picker.shadowRoot &&
              plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown') &&
              plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown').options.length > 0
            );

          }).then(() => {

            let subs = plan_picker.shadowRoot.querySelector('[id*="group-0-skio_plan_picker_"]')
            let otp = plan_picker.shadowRoot.querySelector('[id*="one-time-skio_plan_"]')
            waitForElement('input.quantity-input[name="quantity"]').then(qty => {
              waitForElement('.js-purchase-options .js-otp').then(js_otp => {
                waitForElement('.js-purchase-options .js-subs').then(js_subs => {

                  js_otp.addEventListener("click", () => {
                    
                    js_otp.classList.add("is-selected");
                    otp.checked = true;
                    otp.dispatchEvent(new Event('change', { bubbles: true }));
                    
                    js_subs.classList.remove("is-selected");

                    qty.value = 1;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));

                  });
                  js_subs.addEventListener("click", () => {
                    js_otp.classList.remove("is-selected");
                    
                    js_subs.classList.add("is-selected");
                    subs.checked = true;
                    subs.dispatchEvent(new Event('change', { bubbles: true }));

                    qty.value = selected_plan_qty;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));

                  });

                  // init
                  js_otp.classList.add("is-selected");
                  otp.checked = true;
                  otp.dispatchEvent(new Event('change', { bubbles: true }));
                  
                  js_subs.classList.remove("is-selected");

                  qty.value = 1;
                  qty.dispatchEvent(new Event('change', { bubbles: true }));
                  /*
                  if(otp.checked){
                    js_otp.classList.add("is-selected");
                  } else {
                    js_subs.classList.add("is-selected");
                    qty.value = selected_plan_qty;
                    qty.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                  */

                }).catch();
              }).catch();
            }).catch();

            // prepare options
            let selling_plans = plan_picker.shadowRoot.querySelector('select.selling-plan-dropdown');
            let selling_plans_options = selling_plans.options;
            let selected_option_default_plan = selected_product.options[0].split(" // ")[2];
            for(let i = 0; i < selling_plans_options.length; i++){

              selling_plans_options[i].hidden = false;
              if(selling_plans_options[i].value == selected_option_default_plan){ 
                selling_plans_options[i].selected = true;
                selling_plans.dispatchEvent(new Event('change', { bubbles: true }))
              }

            }

            waitForElement('.js-subs .selling-plan-dropdown').then(delivery_options => {
              delivery_options.addEventListener("change", (e) => {

                let selected_plan_id = e.target.value.split(":")[0];
                // let selected_plan_qty = e.target.value.split(":")[1];

                for(let i = 0; i < selling_plans_options.length; i++){
                  if(selling_plans_options[i].value == selected_plan_id){ 
                    selling_plans_options[i].selected = true;
                    selling_plans.dispatchEvent(new Event('change', { bubbles: true }))
                  }
                }
                
              });
            }).catch();

          }).catch();

      }).catch();

    }).catch();

  } // page_targeted
} // if(window.sessionStorage.getItem("GLW-02") == "v1")

//
// [GLW-03]
//

let activation_param = "pt=freegift";

const add_item_to_cart = (var_id) =>{
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [
            {
                id: var_id,
                quantity: 1,
                properties: {
                  source: "email signup",
                  _discount: "email signup"
                }
            }
            ]
        })
    }).then(res => res.json()).then(data => {
        console.log('Added to cart:', data);
        waitForElement('input[data-quantity-variant-id]').then(qty_input => {
            qty_input.dispatchEvent(new Event('change', { bubbles: true }));
        }).catch();
    }).catch(err => console.error('Error adding to cart:', err));
}

if(window.sessionStorage.getItem("[GLW-03] in-cart treatment") || window.location.href.indexOf(activation_param) > -1){
  window.sessionStorage.setItem("[GLW-03] in-cart treatment", true);

  waitUntil(() => {
      return document.querySelectorAll('cart-drawer-items table.cart-items .cart-item-details').length > 0;
  }).then(() => {

      let review_cart = () => {

          let cart_items = document.querySelectorAll('cart-drawer-items table.cart-items tr.cart-item');
          let show_gwp = false;
          for(let i = 0; i < cart_items.length; i++){
              if(cart_items.length > 0){
                  show_gwp = true;
              }
              if(cart_items[i].innerText.indexOf("source: email signup") > -1){
                  show_gwp = false;
                  break;
              }
          }

          if(show_gwp){
              // an item is in the cart AND not the offer
              console.log("setting it up")
              
              if(document.querySelectorAll('.drawer-cart-items-wrapper .js-offer').length == 0){
                  document.querySelector('.drawer-cart-items-wrapper').insertAdjacentHTML("afterbegin", `
                      <style>
                      .js-offer{
                          background: #f9f0e2 url(https://greatlakeswellness.com/cdn/shop/files/1x1_VarietyStickPack_6ct_FOP-2.png?v=1750950904&width=300) no-repeat;
                          background-size: 100px;
                          background-position: 10px -10px;
                          margin: 1rem 0;
                          padding: 1rem;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                      }
                      
                      .js-offer > div:first-child{
                          padding-left: 100px;
                      }
                      .js-offer > div:last-child{
                          text-align: center;
                      }
                      .js-offer > div span{
                          display: block;
                          font-size: .75rem;
                      }
                      .js-offer > div:last-child span{
                          margin-top: -.5rem;
                      }
                      .js-offer #gwp-atc{
                          transform: scale(.75)
                      }
                      @media(max-width: 525px){
                          .js-offer{
                              display: block;
                          }
                          .js-offer > div:last-child{
                              text-align: left;
                              margin-left: 75px;
                          }        
                          .js-offer #gwp-atc{
                              margin-left: 0;
                          }   
                          .js-offer > div:last-child span{
                              margin-left: 55px;
                          }
                      }

                      </style>
                      <div class="js-offer">
                          <div>
                              Claim your <strong>FREE</strong> Collagen Peptide Variety Pack
                              <div><span>For Orders Over $40</span></div>
                          </div>
                          <div>
                              <div id="gwp-atc" class="cart-checkout-button btn-primary">Add to Cart</div>
                              <span>a $11.99 value</span>
                          </div>
                          
                      </div>
                  `)
              }
          } else {
              console.log("tearing it down")
              if(document.querySelectorAll('.js-offer') > 0){
                  document.querySelector('.js-offer').remove();
              }
          }

      } // review_cart();

      // init
      setTimeout(() => {
          review_cart();
      }, 1500)

      observeSelector('cart-drawer-items table.cart-items tr.cart-item', line_item => {
          review_cart();
          console.log();
      });

      observeSelector('#gwp-atc', gwp_atc => {
          gwp_atc.addEventListener("click", (e) => {
              add_item_to_cart(42809688064135); // 6ct Flavored Collagen Peptide Variety Pack
              gwp_atc.parentNode.style.opacity = 0.5;
              setTimeout(() => {
                  gwp_atc.parentNode.remove();
              }, 750)
          });
      });


  }).catch();

  observeSelector('[id^="alia"]', popup => {
    // console.log("block alia");
    popup.remove();

    const interval = setInterval(() => {
      document.body.style.overflow = "auto";
    }, 500);

    // in case it re-sets, keep trying and clear it after 20s
    setTimeout(() => {
      clearInterval(interval);
      console.log("stopped");
    }, 20000);

  });

}

//
//
//

async function update_cart_data() {
  try {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error("Failed to fetch cart");
    const cart = await res.json();

    window.cart_data = cart;
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", { 
        detail: { cart },
        bubbles: true
      })
    );

    return cart;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
}

window.cart_css_selector = "#CartDrawer";
waitForElement(window.cart_css_selector).then(cart => {

  let current_state = cart.innerText.toLowerCase();
  setInterval(() => {
    if(document.querySelector(window.cart_css_selector).innerText.toLowerCase() != current_state){
      console.log("cart updated -- get data");
      update_cart_data();
      // set new current state
      current_state = document.querySelector(window.cart_css_selector).innerText.toLowerCase();
    }
  }, 2000); // 2s

}).catch();

//
//
//
//
//

// support for proteus pp_offers
if(window.location.href.indexOf("qa=pp") > -1){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-greatlakeswellness.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: window.cart_pp_offers
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

setTimeout(() => {
  if(!window.sessionStorage.getItem("Proteus pp-session-id")){ // && window.sessionStorage.getItem("Proteus PP QA")
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}, 500); // delay to reduce API clogging

async function get_proteus_product_data(prod_id) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-greatlakeswellness.fly.dev/api/catalog?lookup=product_alt&id=${prod_id}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}


document.addEventListener("cart:change", (e) => {

  console.log("pp cart_change", e.detail);

  for(let i = 0; i < e.detail.cart.items.length; i++){
    
    let prod_id = e.detail.cart.items[i].product_id;
    let var_id = e.detail.cart.items[i].variant_id;

    console.log("pp cart change checking", prod_id, window.cart_pp_offers.some(obj => obj.pp_offer_id === prod_id))

    if(!window.cart_pp_offers.some(obj => obj.pp_offer_id == prod_id)){ // && window.cart_pp_offers.length == 0
      get_proteus_product_data(prod_id).then(data => {
        
        console.log("data", data);

        let prod_title = data.product.title.toLowerCase();
        let var_data = data.product.variants.edges.find(obj => obj.node.id.indexOf(var_id) > -1);

        if(var_data && prod_title.indexOf("gift card") == -1){
          
          let price = parseFloat(var_data.node.price);
          let compare_at_price = parseFloat(var_data.node.comparAtPrice);

          if(compare_at_price > price){

            window.cart_pp_offers.push({
              "pp_offer_id": prod_id,
              "pp_offer_banner_title": "It's not too late to add another to your order and save!",
              "pp_offer_banner_subtitle": "",
              "pp_offer_title": data.product.title,
              "pp_offer_image_url": data.product.featuredImage.url,
              "pp_offer_description": [
                var_data.node.title
              ],
              "pp_offer_compare_at": (compare_at_price).toFixed(2),
              "pp_offer_price": (price).toFixed(2),
              "changes": [{
                "type": "add_variant",
                "variantId": var_id,
                "quantity": 1,
                "discount": {
                  "value": 0,
                  "valueType": "percentage",
                  "title": "0% off post purchase"
                }
              }]
            });

          } else {

            window.cart_pp_offers.unshift({
              "pp_offer_id": prod_id,
              "pp_offer_banner_title": "It's not too late to add another to your order and save!",
              "pp_offer_banner_subtitle": "Get 15% Off",
              "pp_offer_title": data.product.title,
              "pp_offer_image_url": data.product.featuredImage.url,
              "pp_offer_description": [
                var_data.node.title
              ],
              "pp_offer_compare_at": (price).toFixed(2),
              "pp_offer_price": (price * .85).toFixed(2),
              "changes": [{
                "type": "add_variant",
                "variantId": var_id,
                "quantity": 1,
                "discount": {
                  "value": 15,
                  "valueType": "percentage",
                  "title": "15% off post purchase"
                }
              }]
            });

          }

        }

      })
    }

  }

  push_pp_offers()
  
})